import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import generalStyles from './style/general.css';
import alignItemsStyles from './style/alignItems.css';
import alignContentStyles from './style/alignContent.css';
import justifyContentStyles from './style/justifyContent.css';

const sizes = ['none', 'xxs', 'xs', 's', 'm', 'l', 'xl'];
const items = ['baseline', 'center', 'flex-end', 'flex-start', 'stretch'];
const content = [
  'center',
  'end',
  'flex-end',
  'flex-start',
  'space-around',
  'space-between',
  'space-evenly',
  'start',
  'stretch',
];

/**
 * A simple, responsive CSS flexbox grid to be used in combination with
 * `GridItem` to create complex layouts. The standard flexbox properties for
 * `align-items`, `align-content` and `justify-content` are available.
 */
export default function Grid({
  alignContent,
  alignItems,
  children,
  columns,
  justifyContent,
  size,
  sizeL,
  sizeM,
  sizeS,
}) {
  const childrenWithProps = React.Children.map(
    children,
    child =>
      child
        ? React.cloneElement(child, { columns, columnGap: sizes[size] })
        : null
  );

  const classes = cx(
    generalStyles.grid,
    alignItemsStyles[alignItems],
    alignContentStyles[alignContent],
    justifyContentStyles[justifyContent],
    `grid--${size}`,
    {
      [`breakPointS-grid--${sizeS}`]: sizeS,
      [`breakPointM-grid--${sizeM}`]: sizeM,
      [`breakPointL-grid--${sizeL}`]: sizeL,
    }
  );

  return <ul className={classes}>{childrenWithProps}</ul>;
}

Grid.propTypes = {
  alignContent: PropTypes.oneOf(content),
  alignItems: PropTypes.oneOf(items),
  children: PropTypes.node.isRequired,
  columns: PropTypes.number,
  justifyContent: PropTypes.oneOf(content),
  size: PropTypes.oneOf(sizes),
  sizeL: PropTypes.oneOf(sizes),
  sizeM: PropTypes.oneOf(sizes),
  sizeS: PropTypes.oneOf(sizes),
};

Grid.defaultProps = {
  columns: 2,
  size: 'm',
};



// WEBPACK FOOTER //
// ./packages/marvel-ui-grid/Grid/index.js